import React from "react";
import { GridColumns, DataGrid } from "@mui/x-data-grid";
import { IResourceComponentsProps, usePermissions } from "@refinedev/core";
import {
  useDataGrid,
  DateField,
  EditButton,
  List,
  ShowButton,
  ListButton,
} from "@refinedev/mui";
import { UserEntityRoleEnum } from "generated";

export const FormList: React.FC<IResourceComponentsProps> = () => {
  const { dataGridProps } = useDataGrid();

  const d = usePermissions();
  const isAdmin = d.data === UserEntityRoleEnum.Admin;

  const columns = React.useMemo<GridColumns<any>>(
    () => [
      {
        field: "createdAt",
        flex: 1,
        headerName: "Date",
        minWidth: 250,
        renderCell: function render({ value }) {
          return <DateField value={value} />;
        },
      },
      {
        field: "label",
        flex: 1,
        headerName: "Label",
        minWidth: 200,
      },
      {
        field: "status",
        flex: 1,
        headerName: "Status",
        minWidth: 200,
      },
      {
        field: "sections",
        flex: 1,
        headerName: "Sections",
        minWidth: 200,
        valueFormatter(params) {
          return params.value.length;
        },
      },
      {
        field: "responses",
        flex: 1,
        headerName: "Responses",
        minWidth: 200,
        renderCell: function render({ row }) {
          return (
            <ListButton resource={`responses`} meta={{ formId: row.id }}>
              View
            </ListButton>
          );
        },
      },
      {
        field: "records",
        flex: 1,
        headerName: "Records",
        minWidth: 200,
        renderCell: function render({ row }) {
          return (
            <ListButton resource={`records`} meta={{ formId: row.id }}>
              View
            </ListButton>
          );
        },
      },
      {
        field: "actions",
        headerName: "Actions",
        sortable: false,
        renderCell: function render({ row }) {
          return (
            <>
              <ShowButton hideText recordItemId={row.id} />

              {isAdmin ? <EditButton hideText recordItemId={row.id} /> : null}
            </>
          );
        },
        align: "center",
        headerAlign: "center",
        minWidth: 80,
      },
    ],
    [isAdmin]
  );

  return (
    <List canCreate={isAdmin}>
      <DataGrid {...dataGridProps} columns={columns} autoHeight />
    </List>
  );
};
